import { styled, Box, Slider } from '../../../base-components';

export const EditorContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    backgroundColor: theme.palette.grey[900],
    borderRadius: theme.shape.borderRadius,
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
}));

export const CropContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
});

export const ControlsContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
}));

export const StyledSlider = styled(Slider)(({ theme }) => ({
    flex: 1,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
}));
